import { RouteComponentProps } from "@reach/router";
import { FunctionComponent, lazy } from "react";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../../shared/ErrorFallback";

interface IProps extends RouteComponentProps {
	loading: React.ReactElement;
}

const LazyKitahara = lazy(() => import(/* webpackChunkName: "KitaharaChat" */ "./KitaharaChat"));
const LazyTimer = lazy(() => import(/* webpackChunkName: "KitaharaTimer" */ "../timer/KitaharaTimer"));
const LazyClock = lazy(() => import(/* webpackChunkName: "KitaharaClock" */ "../clock/KitaharaClock"));

const KitaharaChatPage: FunctionComponent<IProps> = (props) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { path: _path, loading } = props;

	const path = window.location.pathname.substring(1).split("/")[0];
	
	if (path === "timer") {
		return <ErrorBoundary FallbackComponent={ErrorFallback}>
			<LazyTimer />
		</ErrorBoundary>;
	}

	if (path === "clock") {
		return <ErrorBoundary FallbackComponent={ErrorFallback}>
			<LazyClock />
		</ErrorBoundary>;
	}

	return <ErrorBoundary FallbackComponent={ErrorFallback}>
		<LazyKitahara loading={loading} />
	</ErrorBoundary>;
};

export default KitaharaChatPage;